import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import { createNotification } from "./Popup";
import "react-phone-input-2/lib/style.css";
import { verificationAPI } from "../utility/services/apiService";
import { validateFields } from "../utility/services/Validation";
import {
  getEmailInfo,
  getPageInfo,
  setToken,
  setUserInfo,
} from "../utility/Common";
import { messages } from "../utility/services/message";
import { getDocuments } from "../utility/services/resources";
import Header from "./layout/Header";
import NavBar from "./layout/NavBar";
import Footer from "./layout/Footer";

const DocumentVerification = () => {
  let navigate = useNavigate();
  // let useLocationData = useLocation()?.state;
  //let emailInfo = useLocationData?.emailInfo;
  let emailInfo = getEmailInfo();
  //let pageInfo = useLocationData?.useLocationData;
  let pageInfo = getPageInfo();

  const [formData, setFormData] = useState({
    Answer: "",
    Question: "",
    IdentificationID: "",
    DocumentNumber: "",
    DocTypeId: "",
    ResourceType: "FirstRequest",
    RQCode: "",
    Eid: emailInfo?.Eid,
    Email: emailInfo?.EmailAddress,
    Action: "",
  });
  const [showQuestion, setShowQuestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isErrormsg, setIsErrormsg] = useState("");
  const [documents, setDocuments] = useState([]);
  const isDocument =
    formData.DocTypeId === "" || formData.DocumentNumber === "";
  const isQuestion = formData.DocTypeId === "SpecialDocument";
  const isIdentification = formData.DocTypeId === "IdentificationDocument";

  const [errors, setErrors] = useState({});

  const validationRules = {
    DocTypeId: {
      required: true,
      isConditionMet: isDocument,
      errorMessage: "Aina ya kitambulisho ni lazima",
    },
    DocumentNumber: {
      required: true,
      isConditionMet: isDocument,
      errorMessage: "Taarifa hii ni lazima",
    },
    Question: {
      required: true,
      isConditionMet: isQuestion,
      errorMessage: "Swali ni lazima",
    },
    Answer: {
      required: true,
      isConditionMet: isQuestion,
      errorMessage: "Jibu ni lazima",
    },
    IdentificationID: {
      required: true,
      isConditionMet: isIdentification,
      errorMessage: "Taarifa hii ni lazima",
    },
  };
  //================================= get documents =============================
  useEffect(() => {
    getAllDocuments();
    setRenewController();
  }, []);
  const getAllDocuments = async () => {
    const result = await getDocuments("Document", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setDocuments(result);
    } else {
      setDocuments([]);
    }
  };

  //=========================== set pageType for renew or new ====================
  const setRenewController = () => {
    if (pageInfo?.pageName == "renew") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        Answer: "",
        Question: "",
        IdentificationID: "",
        DocumentNumber: "",
        DocTypeId: 2,
        ResourceType: "FirstRequest",
        RQCode: "",
        Eid: emailInfo?.Eid,
        Email: emailInfo?.EmailAddress,
      }));
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsErrormsg("");
    const validationErrors = validateFields(formData, validationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = JSON.stringify(formData);
      if (formData.DocTypeId == 1 || formData.DocTypeId == 4) {
        //=====================  Passport verification process  =======================//
        verificationAPI(payload, "document_search")
          .then((result) => {
            setIsLoading(false);
            if (result.code === 1) {
              console.log("Renew result:", result);
              if (
                result?.status === 1 ||
                result?.status === 0 ||
                result?.status === 2
              ) {
                setShowQuestions(true);
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  Question: result.question,
                  Answer: "",
                }));
              } else if (result?.status === 3) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                navigate("/application");
              } else if (result?.status === 4) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                const sms =
                  "Nambari ya Utambulisho imetumwa kwenye Barua pepe yako, itumie kuendelea na ombi";
                const info = { type: "success", message: sms };
                createNotification(info)();
                navigate("/continue");
              } else if (result?.status === 5) {
                setToken(result?.auth);
                setUserInfo(result.data);
                navigate("/upload-photo");
                const sms = result?.message ? result?.message : "Weka picha";
                const info = { type: "success", message: sms };
                createNotification(info)();
              }
            } else {
              setShowQuestions(false);
              setFormData((prevFormData) => ({
                ...prevFormData,
                Answer: "",
                Question: "",
                IdentificationID: "",
                DocumentNumber: "",
                DocTypeId: "",
                ResourceType: "FirstRequest",
                RQCode: "",
              }));
              setIsErrormsg(result.message);
              const info = { type: "error", message: result?.message };
              createNotification(info)();
            }
          })
          .catch((error) => {
            setIsLoading(false);
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          });
      } else if (formData.DocTypeId == 2) {
        //==========================  ETD verification process  ====================//
        verificationAPI(payload, "document_search")
          .then((result) => {
            setIsLoading(false);
            if (result.code === 1) {
              if (
                result?.status === 1 ||
                result?.status === 0 ||
                result?.status === 2
              ) {
                setShowQuestions(true);
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  Question: result.question,
                  Answer: "",
                }));
              } else if (result?.status === 3) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                navigate("/application");
              } else if (result?.status === 4) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                const sms =
                  "Nambari ya Utambulisho imetumwa kwenye Barua pepe yako, itumie kuendelea na ombi";
                const info = { type: "success", message: sms };
                createNotification(info)();
                navigate("/continue");
              }
            } else {
              setShowQuestions(false);
              setFormData((prevFormData) => ({
                ...prevFormData,
                Answer: "",
                Question: "",
                IdentificationID: "",
                DocumentNumber: "",
                DocTypeId: "",
                ResourceType: "FirstRequest",
                RQCode: "",
              }));
              setRenewController();
              setIsErrormsg(result.message);
              const info = { type: "error", message: result?.message };
              createNotification(info)();
            }
          })

          .catch((error) => {
            setIsLoading(false);
            setRenewController();
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          });
      } else if (formData.DocTypeId == 3 || formData.DocTypeId == 5) {
        //======================  NIda verification process  =======================//
        setFormData((prevFormData) => ({
          ...prevFormData,
          Answer: "",
          Question: "",
          IdentificationID: "",
          DocumentNumber: formData?.DocumentNumber,
          DocTypeId: formData?.DocTypeId,
          Action: "FirstRequest",
          ResourceType: "FirstRequest",
          RQCode: "",
          Eid: emailInfo?.Eid,
          Email: emailInfo?.EmailAddress,
        }));
        verificationAPI(payload, "nida_application")
          .then((result) => {
            setIsLoading(false);
            const rqCode = result?.data?.NidaResponse?.RQCode;

            if (result.code == 1) {
              if (
                result?.status == 1 ||
                result?.status == 0 ||
                result?.status == 2
              ) {
                setShowQuestions(true);
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  Question: result?.data?.NidaResponse?.SW,
                  RQCode: rqCode,
                  Answer: "",
                  Action: "",
                  ResourceType: "",
                }));
              } else if (result?.status === 3) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                navigate("/application");
              } else if (result?.status === 4) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                const sms =
                  "Nambari ya Utambulisho imetumwa kwenye Barua pepe yako, itumie kuendelea na ombi";
                const info = { type: "success", message: sms };
                createNotification(info)();
                navigate("/continue");
              }
            } else {
              setShowQuestions(false);
              setFormData((prevFormData) => ({
                ...prevFormData,
                Answer: "",
                Question: "",
                IdentificationID: "",
                DocumentNumber: "",
                DocTypeId: "",
                ResourceType: "FirstRequest",
                RQCode: "",
              }));
              setIsErrormsg(result.message);
              const info = { type: "error", message: result?.message };
              createNotification(info)();
            }
          })
          .catch((error) => {
            setIsLoading(false);
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          });
      } else if (pageInfo?.pageName == "renew") {
        //==============================     =======================//
        verificationAPI(payload, "document_search")
          .then((result) => {
            setIsLoading(false);
            if (result.code === 1) {
              if (
                result?.status === 1 ||
                result?.status === 0 ||
                result?.status === 2
              ) {
                setShowQuestions(true);
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  Question: result.question,
                  Answer: "",
                }));
              } else if (result?.status === 3) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                navigate("/application");
              } else if (result?.status === 4) {
                setToken(result?.auth);
                setUserInfo(result.data[0]);
                const sms =
                  "Nambari ya Utambulisho imetumwa kwenye Barua pepe yako, itumie kuendelea na ombi";
                const info = { type: "success", message: sms };
                createNotification(info)();
                navigate("/continue");
              }
            } else {
              setShowQuestions(false);
              setFormData((prevFormData) => ({
                ...prevFormData,
                Answer: "",
                Question: "",
                IdentificationID: "",
                DocumentNumber: "",
                DocTypeId: "",
                ResourceType: "FirstRequest",
                RQCode: "",
              }));
              setIsErrormsg(result.message);
              const info = { type: "error", message: result?.message };
              createNotification(info)();
            }
          })

          .catch((error) => {
            setIsLoading(false);
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          });
      }
    } else {
      const info = { type: "error", message: validateFields.DocTypeId };
      createNotification(info)();
    }
  };
  return (
    <>
      <Header />
      <div className="container">
        <NavBar />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <br />
              <div className="col-sm-6 text-justify">
                <h5 className="page-header m-r-t-1">
                  <Link>Ombi la Hati ya Dharura (ETD)</Link>
                </h5>
                {!showQuestion && pageInfo?.pageName !== "renew" && (
                  <h5 style={{ fontSize: "14px", lineHeight: "1.6" }}>
                    Chagua aina ya kitambulisho ulichonacho na kisha weka namba
                    ya kitambulisho
                  </h5>
                )}
                {showQuestion && pageInfo?.pageName !== "renew" && (
                  <h5 style={{ fontSize: "14px", lineHeight: "1.6" }}>
                    Endelea na kujibu Maswali ili kuhakiki Taarifa za Nyaraka
                    yako
                  </h5>
                )}
                {pageInfo?.pageName == "renew" && (
                  <h5 style={{ fontSize: "14px", lineHeight: "1.6" }}>
                    Ingiza nambari ya Hati yako ya Dharura
                  </h5>
                )}
              </div>
              <div className="col-sm-1"></div>
              <div className="col-sm-5">
                <h5 className="page-header m-r-t-1">
                  <Link>Taarifa za Msingi</Link>
                </h5>
                <p className="help-block help-block-error"></p>

                <form id="passport-application-form" onSubmit={handleSubmit}>
                  <input type="hidden" name="_csrf" value="" />

                  {!showQuestion && (
                    <>
                      {pageInfo?.pageName !== "renew" && (
                        <div className="form-group field-passportbasicdetails-applicationtypeid required">
                          <label
                            className="control-label"
                            htmlFor="passportbasicdetails-applicationtypeid"
                          >
                            Chagua kitambulisho
                          </label>
                          <select
                            id="DocTypeId"
                            className="form-control"
                            name="DocTypeId"
                            value={formData.DocTypeId}
                            onChange={handleChange}
                            aria-required="true"
                          >
                            <option value="">Chagua Kitambulisho</option>
                            {documents.length > 0 &&
                              documents?.map((document) => (
                                <option
                                  key={document.ResourceID}
                                  value={document.ResourceID}
                                >
                                  {document.ResourceName}
                                </option>
                              ))}
                          </select>
                          <div
                            type="invalid"
                            style={{
                              color: "red",
                              fontSize: "13px",
                              fontFamily: "time new roman",
                            }}
                          >
                            <i>
                              {errors.DocTypeId && <p>{errors.DocTypeId}</p>}
                            </i>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {/*================ IF PASSPORT====================*/}
                  <div>
                    {formData.DocTypeId == 1 && !showQuestion ? (
                      <div className="form-group field-passportbasicdetails-PriviousID required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-PriviousID"
                        >
                          Nambari ya Passpoti
                        </label>
                        <input
                          type="text"
                          id="DocumentNumber"
                          className="form-control"
                          name="DocumentNumber"
                          value={formData.DocumentNumber}
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9]*$/;
                            if (
                              regex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              handleChange(e);
                            }
                          }}
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>
                            {errors.DocumentNumber && (
                              <p>{errors.DocumentNumber}</p>
                            )}
                          </i>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/*================ END && IF PASSPORT====================*/}
                  <div>
                    {formData.DocTypeId == 2 && !showQuestion ? (
                      <>
                        {pageInfo?.pageName !== "renew" && (
                          <div className="form-group field-passportbasicdetails-PriviousID required">
                            <label
                              className="control-label"
                              htmlFor="passportbasicdetails-PriviousID"
                            >
                              Nambari ya Hati ya Dharura
                            </label>
                            <input
                              type="text"
                              id="DocumentNumber"
                              className="form-control"
                              name="DocumentNumber"
                              value={formData.DocumentNumber}
                              onChange={(e) => {
                                const regex = /^[a-zA-Z0-9]*$/;
                                if (
                                  regex.test(e.target.value) ||
                                  e.target.value === ""
                                ) {
                                  handleChange(e);
                                }
                              }}
                            />
                            <div
                              type="invalid"
                              style={{
                                color: "red",
                                fontSize: "13px",
                                fontFamily: "time new roman",
                              }}
                            >
                              <i>
                                {" "}
                                {errors.DocumentNumber && (
                                  <p>{errors.DocumentNumber}</p>
                                )}
                              </i>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      ""
                    )}

                    {/*================ END && IF ETD RENEW ====================*/}
                    {pageInfo?.pageName == "renew" && !showQuestion ? (
                      <div className="form-group field-passportbasicdetails-PriviousID required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-PriviousID"
                        >
                          Nambari ya Hati ya Dharura
                        </label>
                        <input
                          type="text"
                          id="DocumentNumber"
                          className="form-control"
                          name="DocumentNumber"
                          value={formData.DocumentNumber}
                          onChange={(e) => {
                            const uppercaseValue = e.target.value.toUpperCase();
                            const regex = /^[A-Z0-9]*$/;
                            if (
                              regex.test(uppercaseValue) ||
                              uppercaseValue === ""
                            ) {
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: uppercaseValue,
                                },
                              });
                            }
                          }}
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>
                            {" "}
                            {errors.DocumentNumber && (
                              <p>{errors.DocumentNumber}</p>
                            )}
                          </i>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/*================ END &&  IF PASSPORT====================*/}
                  <div>
                    {formData.DocTypeId == 3 && !showQuestion ? (
                      <div className="form-group field-passportbasicdetails-PriviousID required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-PriviousID"
                        >
                          Ingiza Nambari ya NIDA
                        </label>
                        <input
                          type="text"
                          id="DocumentNumber"
                          className="form-control"
                          name="DocumentNumber"
                          value={formData.DocumentNumber}
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9]*$/;
                            if (
                              regex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              handleChange(e);
                            }
                          }}
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>
                            {" "}
                            {errors.DocumentNumber && (
                              <p>{errors.DocumentNumber}</p>
                            )}
                          </i>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <p style={{ color: "red" }}>{isErrormsg}</p>
                  </div>

                  {/*================ AND && IF PASSPORT YA MDHAMINI ====================*/}
                  <div>
                    {formData.DocTypeId == 4 && !showQuestion ? (
                      <div className="form-group field-passportbasicdetails-PriviousID required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-PriviousID"
                        >
                          Ingiza Nambari ya Passpoti ya Mdhamini
                        </label>
                        <input
                          type="text"
                          inputMode="text"
                          pattern="[A-Za-z0-9]*"
                          id="PriviousID"
                          className="form-control"
                          name="DocumentNumber"
                          value={formData.DocumentNumber}
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9]*$/;
                            if (
                              regex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              handleChange(e);
                            }
                          }}
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>
                            {" "}
                            {errors.DocumentNumber && (
                              <p>{errors.DocumentNumber}</p>
                            )}
                          </i>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/*================ AND && IF NIDA YA MDHAMINI ====================*/}
                  <div>
                    {formData.DocTypeId == 5 && !showQuestion ? (
                      <div className="form-group field-passportbasicdetails-PriviousID required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-PriviousID"
                        >
                          Ingiza nambari ya NIDA ya Mdhamini
                        </label>
                        <input
                          type="tel"
                          id="PriviousID"
                          className="form-control"
                          name="DocumentNumber"
                          value={formData.DocumentNumber}
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9]*$/;
                            if (
                              regex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              handleChange(e);
                            }
                          }}
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>
                            {" "}
                            {errors.DocumentNumber && (
                              <p>{errors.DocumentNumber}</p>
                            )}
                          </i>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/*================ AND && QUESTIONS AND ANSWERS ====================*/}
                  {showQuestion && !isLoading && (
                    <div>
                      <div
                        className="form-group field-passportbasicdetails-PriviousID required"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <b>Swali:</b>
                        <input
                          style={{
                            width: "100%",
                            border: "none",
                            marginRight: "5px",
                          }}
                          value={formData?.Question}
                          onChange={handleChange}
                          disabled
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "Times New Roman",
                            marginRight: "10px",
                          }}
                        >
                          <i>{errors.Question && <p>{errors.Question}</p>}</i>
                        </div>
                      </div>

                      <div className="form-group field-passportbasicdetails-PriviousID required">
                        <label
                          className="control-label"
                          htmlFor="passportbasicdetails-PriviousID"
                        >
                          Jibu:
                        </label>
                        <input
                          type="text"
                          id="Answer"
                          className="form-control"
                          name="Answer"
                          value={formData?.Answer}
                          onChange={(e) => {
                            const upperCaseValue = e.target.value.toUpperCase();
                            const regex = /^[a-zA-Z0-9 '-]*$/;
                            if (
                              regex.test(upperCaseValue) ||
                              upperCaseValue === ""
                            ) {
                              e.target.value = upperCaseValue;
                              handleChange(e);
                            }
                          }}
                          aria-required="true"
                        />
                        <div
                          type="invalid"
                          style={{
                            color: "red",
                            fontSize: "13px",
                            fontFamily: "time new roman",
                          }}
                        >
                          <i>{errors.Answer && <p>{errors.Answer}</p>}</i>
                        </div>
                      </div>
                      <br />
                    </div>
                  )}

                  {/*================ END ====================*/}

                  <div className="box-footer">
                    <button
                      className="btn btn-default btn-label-next pull-right"
                      disabled={isLoading}
                    >
                      {isLoading ? "Subiri.. " : "Hifadhi na Endelea"} |{" "}
                      <i className="fa fa-angle-double-right"></i>
                    </button>
                    <br />
                    <div style={{ marginTop: "15px" }}></div>
                  </div>
                </form>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentVerification;
